module.exports = __webpack_public_path__ + "media/23.48429343.mp3";